import React from "react";

function About (){
    return <h1>ABOUT</h1>
}

export default About;